import { ProductInterest } from 'modules/data/domain';
import { useMemo } from 'react';
import { useUserBetaFeatures } from 'shared/hooks';

import { productInterestText } from './QualificationQuestions.helpers';

export const useProductInterestItems = () => {
    const { isCin7 } = useUserBetaFeatures();

    return useMemo(
        () =>
            Object.values(ProductInterest)
                .filter((value) => value !== ProductInterest.Cin7Core || isCin7)
                .map((value) => ({
                    id: value,
                    text: productInterestText(value),
                })),
        [isCin7]
    );
};
